import React from "react";
import { Form, Select } from "antd";
const FormItem = Form.Item;
const RolePicker = ({ form, roles }) => {
  const { getFieldDecorator } = form;
  const { Option } = Select;
  let list = [];
  switch (roles) {
    case "other":
      list = [
        "ACQUISITOR",
        "BUYER",
        "DOCUMENT_ADMIN",
        "FINANCE_ADMIN",
        "PDI",
        "PRICE_NEGOTIATOR",
        "PRICING",
        "FINANCE",
      ];
      break;
    case "appraiser":
      list = ["APPRAISAL_USER"];
      break;
    case "sales":
      list = ["SALES_USER"];
      break;
    case "boh":
      list = ["BOH"];
      break;
    case "branch-head":
      list = ["BRANCH_HEAD_USER"];
      break;
    case "pricing":
      list = ["PRICING"];
      break;
    case "tnt":
      list = ["TNT"];
      break;
    case "supervisor":
      list = ["SUPERVISOR"];
      break;
    case "ali":
      list = ["ALI"];
      break;
    case "dispatcher":
      list = ["DISPATCHER"];
      break;
    case "abm":
      list = ["DIRECTORS_USER"];
      break;
    case "mobbi-supervisor":
      list = ["MOBBI_SUPERVISOR"];
    case "general-manager":
      list = ["GENERAL_MANAGER"];
      break;
    case "finance":
      list = ["FINANCE"];
      break;
    default:
      list;
  }
  return (
    <FormItem label="Role">
      {getFieldDecorator("role", {
        rules: [{ required: true, message: "Role is required" }],
        initialValue: list[0],
      })(
        <Select
          placeholder="Select a person"
          disabled={roles === "other" ? false : true}>
          {list.map((role, index) => (
            <Option key={index} value={role}>
              {role}
            </Option>
          ))}
        </Select>
      )}
    </FormItem>
  );
};

export default RolePicker;



// WEBPACK FOOTER //
// src/comp/RolePicker.js